var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "session-list" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip.bottom",
            value: _vm.editorsTooltip,
            expression: "editorsTooltip",
            modifiers: { bottom: true }
          }
        ],
        staticClass: "avatar-list",
        on: {
          click: function($event) {
            _vm.popoverVisible = !_vm.popoverVisible
          }
        }
      },
      [
        _vm.sessionsPopover.length > 0
          ? _c("div", { staticClass: "avatardiv icon-more" })
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.sessionsVisible, function(session) {
          return _c("Avatar", {
            key: session.id,
            style: _vm.sessionStyle(session),
            attrs: {
              user: session.userId ? session.userId : session.guestName,
              "is-guest": session.userId === null,
              "disable-tooltip": true,
              size: 32
            }
          })
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.popoverVisible,
            expression: "popoverVisible"
          }
        ],
        staticClass: "popovermenu menu-right"
      },
      [
        _c("PopoverMenu", { attrs: { menu: _vm.sessionsPopover } }),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }